import GroupInfo from "@/pages/groepen/$groupId/gegevens"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/groepen/$groupId/gegevens/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "groups"),
})

function RouteComponent() {
  const { groupId } = useParams({ from: "/beheer/groepen/$groupId" })

  return <GroupInfo groupId={Number(groupId)} />
}
